module.exports = __webpack_public_path__ + "assets/img/img_6_5.ae2fd906.png";